{
    "NavigationAll": "Alle",
    "NavigationReporting": "Berichterstattung",
    "NavigationAdministration": "Verwaltung",
    "NavigationProvisioning": "Bereitstellung",
    "NavigationDevices": "Geräte",
    "NavigationEndpoints": "Endpunkte",
    "NavigationTrunking": "Trunking",
    "NavigationHospitality": "Gastfreundschaft",
    "NavigationTrunkgateways": "Trunk-Gateways",
    "NavigationVoicemailservices": "Voicemail-Dienste",
    "NavigationConferencedevices": "Konferenzgeräte",
    "NavigationAgents": "Agenten",
    "NavigationDirectory": "Verzeichnis",
    "NavigationCodes": "Codes",
    "NavigationPartitions": "Partitionen",
    "NavigationTelephonyservers": "Telefonie-Server",
    "NavigationCmenvironments": "Zentrale Verwaltungsumgebungen",
    "NavigationApplicationusers": "Anwendungsbenutzer",
    "NavigationOmnichannel": "Omnichannel",
    "NavigationRecording": "Aufzeichnung",
    "NavigationMessages": "Mitteilungen",
    "NavigationDatabase": "Datenbank",
    "NavigationStatustools": "Status und werkzeuge",
    "NavigationLicenses": "Lizenzen",
    "NavigationLogging": "Protokollierung",
    "NavigationLogmanagement": "Protokollverwaltung",
    "NavigationAudittrail": "Buchungskontrolle",
    "NavigationTelephonemodulestatus": "Status des Telefonmoduls",
    "NavigationOmnichannelmodulestatus": "Omnichannel-Status",
    "NavigationCallcontrol": "Anrufsteuerung",
    "NavigationServerstatus": "Server Status",
    "NavigationNewAnalytics": "Unternehmen hinzufügen",
    "NAME": "LanguageMainNavigation",
    "InsightsHub": "Einblicke",
    "Presence": "Anwesenheit",
    "NavigationUserManagement": "Benutzerverwaltung",
    "NavigationManageUsersDevice": "Benutzer verwalten",
    "NavigationEasyProvisioning": "Einfache Bereitstellung",
    "NavigationManageQueues": "Warteschlangen verwalten"
}